var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader'),_c('router-view',{attrs:{"tag":"main"}}),_c('Player')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }